{
  "email_unsubscribe": {
    "unsubscribe": "Se désabonner",
    "confirm_title": "Se désabonner",
    "confirm_content": "Êtes-vous sûr de vouloir vous désabonner ?",
    "its_official": "C'est officiel",
    "unsubscribed_thanks": "Vous vous êtes désabonné. Merci !",
    "all_communications": "toutes les communications"
  },
  "campaign_templates": {
    "campaign_templates": "Modèles de campagne",
    "new_template": "Nouveau modèle",
    "template_title": "Titre du modèle",
    "type_template_title": "Tapez le titre du modèle",
    "save_as_template": "enregistrer comme modèle",
    "rename_template": "Renommer le modèle",
    "please_enter_title": "Veuillez saisir un titre",
    "select_template_status": "sélectionner le statut du modèle",
    "template": "Modèle",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "job_title": "Titre du poste",
    "company_name": "Nom de l'entreprise",
    "primary_email": "Email principal",
    "id": "Id"
  },
  "template_actions": {
    "template_actions": "actions du modèle",
    "confirm_archive_title": "Êtes-vous sûr de vouloir archiver ce modèle ?",
    "confirm_archive_content": "Cliquez sur confirmer pour archiver",
    "confirm_clone_title": "Êtes-vous sûr de vouloir cloner ce modèle ?",
    "confirm_clone_content": "Cliquez sur confirmer pour cloner ce modèle.",
    "confirm_restore_content": "Veuillez confirmer pour restaurer le modèle.",
    "confirm_restore_title": "Restaurer le modèle ?"
  },
  "campaigns": {
    "status": {
      "all": "Tous",
      "draft": "Brouillon",
      "scheduled": "Programmé",
      "sending": "Envoi en cours",
      "sent": "Envoyé"
    },
    "filters": {
      "filter": "Filtrer",
      "clear_all": "Tout effacer",
      "created_by": "Créé par",
      "created_at": "Créé le",
      "scheduled_at": "Programmé le",
      "sent_at": "Envoyé le",
      "workspaces": "Espaces de travail",
      "workspaces_tooltip": "Filtrer par espaces de travail ou applications auxquels vous avez accès",
      "show_filters": "afficher les filtres",
      "filters_active": "{{count}} filtres sont actifs",
      "search_employees": "commencez à taper pour rechercher des employés",
      "search_workspace": "Rechercher un espace de travail",
      "type_email_search": "Tapez l'email pour rechercher",
      "from": "De",
      "to": "À",
      "validation_date_range": "Veuillez sélectionner une date de début et une date de fin"
    },
    "actions": {
      "send_now": "Envoyer maintenant",
      "cancel_schedule": "Annuler la programmation",
      "save_as_template": "Enregistrer comme modèle",
      "clone": "Cloner",
      "ok": "Ok",
      "campaign_actions": "actions de campagne"
    },
    "messages": {
      "send_now_header": "Envoyer la campagne maintenant ?",
      "send_now_caption": "Une fois envoyée, la campagne ne peut pas être annulée ou révoquée. Êtes-vous sûr de vouloir continuer ?",
      "cancel_schedule_title": "Annuler la campagne programmée ?",
      "cancel_schedule_content": "Nous déplacerons cette campagne vers l'onglet Brouillons.",
      "cancel_success": "Votre campagne programmée a été annulée avec succès.",
      "cancel_error": "L'annulation de la campagne a échoué. Actualisez et réessayez."
    },
    "headers": {
      "all_campaigns": "Toutes les campagnes",
      "new_campaign": "Nouvelle campagne",
      "templates": "Modèles"
    },
    "tooltips": {
      "continuous_sending": "Envoi continu autorisé"
    }
  },
  "campaign": {
    "clone": {
      "confirm_title": "Êtes-vous sûr de vouloir cloner cette campagne ?",
      "confirm_content": "Cliquez sur confirmer pour cloner cette campagne."
    },
    "add_recipient": {
      "modal_title": "Ajouter un nouveau destinataire",
      "email_label": "E-mail",
      "email_placeholder": "Saisir l'e-mail",
      "send_scheduled": "Envoyer comme prévu",
      "send_now": "Envoyer maintenant",
      "placeholder": "Tapez l'e-mail du destinataire pour envoyer la campagne..."
    },
    "analytics": {
      "activities": "Activités",
      "clear_selection": "Effacer la sélection",
      "log_new_activity": "Enregistrer une nouvelle activité",
      "contact": "Contact",
      "company": "Entreprise",
      "location": "Localisation",
      "last_interaction": "Dernière interaction",
      "latest_status": "Dernier statut",
      "add_to_list": "Ajouter à la liste",
      "add_tags": "Ajouter des étiquettes",
      "log_new_activity_action": "Enregistrer une nouvelle activité"
    },
    "filters": {
      "filter": "Filtrer",
      "delivery_status": "Statut de livraison",
      "clicked_link": "Lien cliqué",
      "clear_all": "Tout effacer",
      "select_status": "Sélectionner le statut",
      "marked_as_spam": "Marqué comme spam",
      "filters_active": "filtres sont actifs",
      "show_filters": "afficher les filtres",
      "select_delivery_status": "sélectionner le statut de livraison"
    },
    "status": {
      "draft": "Brouillon",
      "scheduled": "Programmé",
      "sending": "Envoi en cours",
      "archived": "Archivé",
      "sent": "Envoyé",
      "unknown": "Inconnu"
    },
    "content": {
      "details": "Détails",
      "subject": "Objet",
      "from": "De",
      "recipients": "Destinataires",
      "attachment": "Pièce jointe",
      "content": "Contenu",
      "campaign_content": "Contenu de la campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "add_new_recipient": "Ajouter un nouveau destinataire",
      "analytics": "Analyses"
    },
    "update": {
      "details": "Détails",
      "subject_placeholder": "Saisir l'objet de la campagne",
      "from": "De",
      "recipient_list": "Liste des destinataires",
      "attachment": "Pièce jointe",
      "no_campaign_data": "Aucune donnée de campagne",
      "content": "Contenu",
      "select_template": "Sélectionner un modèle",
      "remove": "Supprimer",
      "campaign_email_template": "Modèle d'e-mail de campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "select_sender": "Sélectionner l'expéditeur",
      "search_list": "Rechercher une liste"
    },
    "remove_content": {
      "confirm_title": "Êtes-vous sûr de vouloir supprimer ce contenu ?",
      "confirm_content": "Cliquez sur le bouton confirmer pour supprimer"
    },
    "settings": {
      "header": "Paramètres",
      "button": "PARAMÈTRES",
      "continuous_sending": "Autoriser l'envoi continu",
      "continuous_sending_caption": "Vous pouvez ajouter des participants supplémentaires après l'envoi de la campagne",
      "resend_existing": "Autoriser le renvoi aux destinataires existants",
      "resend_existing_caption": "Les destinataires peuvent recevoir cette campagne plus d'une fois.",
      "click_tracking": "Suivi des clics",
      "click_tracking_caption": "Surveille les liens dans un e-mail et enregistre quand les destinataires cliquent dessus",
      "open_tracking": "Suivi d'ouverture",
      "open_tracking_caption": "Suit quand un e-mail est ouvert par le destinataire"
    },
    "warning": {
      "all_set": "Tout est prêt",
      "high_risk_removed": "Tout e-mail à haut risque sera supprimé des destinataires de la campagne.",
      "view_list": "Voir la liste",
      "clean_list": "Nettoyer la liste",
      "cleaning_in_progress": "Le nettoyage de la liste est en cours"
    },
    "attachment": {
      "cannot_delete": "Impossible de supprimer :",
      "cannot_upload": "Impossible de télécharger :"
    },
    "create": {
      "header": "Nouvelle campagne e-mail",
      "name_label": "Nom",
      "name_placeholder": "Nom",
      "name_required": "veuillez saisir un nom",
      "create_button": "Créer une campagne"
    },
    "template": {
      "select": "Sélectionner {{title}}",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "job_title": "Titre du poste",
      "company_name": "Nom de l'entreprise",
      "primary_email": "E-mail principal",
      "id": "Id"
    },
    "actions": {
      "send_test": "Envoyer un test"
    },
    "archive": {
      "confirm_title": "Êtes-vous sûr de vouloir archiver cette campagne ?",
      "confirm_content": "Cliquez sur confirmer pour archiver cette campagne."
    },
    "select": {
      "placeholder": "Choisir une campagne"
    },
    "add_to_campaign": {
      "header": "Ajouter à la campagne",
      "select_campaign": "Sélectionner une campagne",
      "confirm_title": "Procéder à l'ajout à la campagne ?",
      "caption": "Vous pouvez ajouter des destinataires supplémentaires aux campagnes d'e-mails continues.",
      "contact": "contact",
      "contacts": "contacts",
      "confirm_content": "Êtes-vous sûr de vouloir ajouter {{count}} {{contactCountText}} à la \"{{campaignTitle}}\" ?",
      "warning": "Cela déclenchera immédiatement la campagne d'e-mail et ne peut pas être annulé"
    },
    "test_email": {
      "send_test": "Envoyer un test",
      "header": "Envoyer un e-mail de test",
      "caption": "Tapez l'e-mail du destinataire pour envoyer la campagne. Une fois envoyé, il ne peut pas être rappelé ou modifié.",
      "email_label": "E-mail",
      "email_placeholder": "Entrez l'e-mail",
      "email_required": "Veuillez entrer un e-mail valide"
    },
    "email_template": {
      "title": "Modèle d'e-mail de campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "wrong_url": "on dirait que vous avez la mauvaise URL."
    },
    "schedule": {
      "send_now": "Envoyer maintenant",
      "time_zone": "Fuseau horaire",
      "select_timezone": "Sélectionner le fuseau horaire",
      "schedule_time": "Heure de programmation",
      "schedule": "Programmer",
      "clean_list_header": "Nettoyer la liste",
      "clean_list_caption": "Veuillez valider les adresses e-mail pour garantir la précision avant d'envoyer des campagnes. Nous supprimerons automatiquement les e-mails à haut risque si vous nettoyez la liste. Ignorer pour continuer sans nettoyer.",
      "send_campaign_now": "Envoyer la campagne maintenant ?",
      "schedule_campaign_header": "Programmer la campagne",
      "send_now_caption": "Une fois envoyée, la campagne ne peut pas être annulée ou révoquée. Êtes-vous sûr de vouloir continuer ?",
      "schedule_campaign_caption": "Vous êtes sur le point de programmer cette campagne pour qu'elle soit envoyée aux destinataires. Êtes-vous sûr ?"
    }
  }
}
